import { Link } from 'react-router-dom';
import { SignupForm } from './components/SignupForm';
import { AuthPageLayout } from './AuthPageLayout';
import { useAuth } from './context/AuthContext';

export function SignupPage() {
  const { errorMessage, successMessage } = useAuth();

  return (
    <AuthPageLayout>
      <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h2 className="text-lg font-semibold text-blue-800 mb-2">Create Your Account</h2>
        <p className="text-blue-700 text-sm">
          After signing up, you will get a verification email from{' '}
          <span className="font-medium">confirmation@pricingtable.ai</span>. Click the link in that message to
          finish setting up your account.
        </p>
      </div>
      {errorMessage && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          <strong>Error:</strong> {errorMessage.description}
        </div>
      )}
      {successMessage && (
        <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          {successMessage}
        </div>
      )}
      <SignupForm />
      <br />
      <span className='text-sm font-medium text-gray-900'>
        I already have an account (
        <Link to="/login" className='underline'>
          go to login
        </Link>
        ).
      </span>
      <br />
    </AuthPageLayout>
  );
}
